__turbopack_context__.v({
  "className": "jetbrains_mono_17685088-module__GWyQzq__className",
  "variable": "jetbrains_mono_17685088-module__GWyQzq__variable",
});
